const autoNgTemplateLoaderTemplate1 = require('./entity-stats.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.entityStats', [])
        .config(entityStatsConfig);

    entityStatsConfig.$inject = ['$routeProvider'];

    function entityStatsConfig($routeProvider) {
        $routeProvider
            .when('/entity-stats', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'EntityStatsController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Entity Stats', icon: NAVIGATION_ICON.LEADERBOARD }
                    ]
                }
            })
    }
})();
